import React, { Component } from 'react'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'
import { storeLastView } from 'actions/lastView'

import { Get } from 'utils/axios'

const HOC = ( WrappedComponent ) => {
  class WithHOC extends Component {
    state = {
      loading: false,
      studentEvaluation: {},
      evaluationList: {},
      showStudentEvaluation: false,
      showGenerateCSV: false,
    }

    onChangeEvaluationsHOC = ( key, val ) => this.setState({ [key]: val })

    load = param => this.setState({ loading: param })
    requestError = error => toast.error( error )
    requestSuccess = success => toast.success( success )

    getSelectedEvaluation = search => {
      this.props.storeLastView({ search })

      Get(
        `/internship_evaluation_forms?query=${ search }`,
        this.getSelectedEvaluationSuccess,
        this.getSelectedEvaluationError,
        this.load,
        this.props.data.ProfileReducer.current_role_id
      )
    }
    getSelectedEvaluationSuccess = payload => {
      let tempData = {}
      payload.data.map(({ 
        internship_evaluation_form, company, student_user,
        external_supervisor, internal_supervisor
      }) => {
        tempData[ internship_evaluation_form.type === 'External'? 'external': 'internal' ] = {
          ... internship_evaluation_form,
          internship: {
            student_name: student_user.name,
            company_name: company.name,
            internal_supervisor: internal_supervisor?.name??'N/A',
            external_supervisor: external_supervisor?.name??'N/A',
          }
        }
      })
      this.setState({ 
        studentEvaluation: tempData,
        showStudentEvaluation: true
      })
    }
    getSelectedEvaluationError = error => this.requestError( error )

    getEvaluations = search => {
      this.props.storeLastView({ search })

      Get(
        `/internship_evaluation_forms?query=${ search }&session_id=${this.props.data.SessionReducer.current_selected_session_id}`,
        this.getEvaluationsSuccess,
        this.getEvaluationsError,
        this.load,
        this.props.data.ProfileReducer.current_role_id
      )
    }
    getEvaluationsSuccess = payload => {
      let tempData = []
      let tempEval = []
      let tempChildren =[]
      payload.data?.[0] && payload.data.map(({
        internship_evaluation_form, 
        company, student_user,
      }) => {
        let tempJSON = []
        if (internship_evaluation_form.type == "External") {
          if (internship_evaluation_form.evaluation) {
            tempJSON = JSON.parse( internship_evaluation_form.evaluation ).data
            tempJSON.map((item) => {
              tempChildren = {
                [item.name]: `Total: ${item.total}`
              }
              item.children.map((child) => {
                tempChildren = {
                  ... tempChildren,
                  [`${item.name.slice(0, 3)}: ${child.name}`]: `Marks: ${child.marks}, Grade: ${child.grade}`,
                }
              })
              tempEval[student_user.name] = {
                ... tempEval[student_user.name],
                ... tempChildren,
              }
            })
          }
          tempChildren = []
          tempData.push({
            type: internship_evaluation_form.type,
            student_name: student_user.name,
            company_name: company.name,
            final_total_marks: internship_evaluation_form.final_total_marks,
            general_comments: internship_evaluation_form.general_comments,
            is_best_intern_awards: internship_evaluation_form.is_best_intern_awards,
            is_confirmed_submission: internship_evaluation_form.is_confirmed_submission,
            is_recommend_industrial_training_excellence: internship_evaluation_form.is_recommend_industrial_training_excellence,
            is_student_passed: internship_evaluation_form.is_student_passed,
            ... tempEval[student_user.name],
          })
        } else if (internship_evaluation_form.type == "Internal") {
          let studentEval = {}
          if (internship_evaluation_form.evaluation) {
            tempJSON = JSON.parse( internship_evaluation_form.evaluation ).data
            let presentationSection = null
            let logBookSection = null
            let reportSection = null

            tempJSON && tempJSON.forEach((title) => {
              if (title.name && title.name.indexOf('Presentation') > -1) {
                presentationSection = title
              } else if (title.name && (title.name.indexOf('PO9') > -1 || title.name.indexOf('Log Book') > -1 || title.name.indexOf('PO7') > -1)) {
                logBookSection = title
                logBookSection.name = 'Log Book (20%)'
                if (logBookSection.data) {
                  logBookSection.data.forEach((item) => {
                    item.name = 'PO9 – PERSONAL SKILLS (100%)'
                  })
                }
              } else if (title.name && title.name.indexOf('Report') > -1) {
                reportSection = title
              }
            })

            const orderedSections = [presentationSection, logBookSection, reportSection].filter(Boolean)

            orderedSections.forEach((title) => {
              let tempChildren = {}
              title.data && title.data.forEach((item) => {
                item.children && item.children.forEach((child) => {
                  tempChildren[`${title.name}: ${item.name.slice(0, 3)}: ${child.name}`] = `Marks: ${child.marks}, Grade: ${child.grade}`
                })
              })
              studentEval[`${title.name}`] = `Total: ${title.total}, Total After Weightage: ${title.total_after_weightage}`
              studentEval = {
                ...studentEval,
                ...tempChildren,
              }
            })
          }
          tempData.push({
            type: internship_evaluation_form.type,
            student_name: student_user.name,
            company_name: company.name,
            final_total_marks: internship_evaluation_form.final_total_marks,
            general_comments: internship_evaluation_form.general_comments,
            is_best_intern_awards: internship_evaluation_form.is_best_intern_awards,
            is_confirmed_submission: internship_evaluation_form.is_confirmed_submission,
            is_recommend_industrial_training_excellence: internship_evaluation_form.is_recommend_industrial_training_excellence,
            is_student_passed: internship_evaluation_form.is_student_passed,
            ...studentEval,
          })
        }
      })
      this.setState({ 
        evaluationList: tempData,
        showGenerateCSV: true
      })
    }
    getEvaluationsError = error => this.requestError( error )

    render = () => {
      return (
        <WrappedComponent
          { ...this.props } 
          studentEvaluation={ this.state.studentEvaluation }
          evaluationList={ this.state.evaluationList }
          onLoadEvaluation={ this.state.loading }
          showStudentEvaluation={ this.state.showStudentEvaluation }
          showGenerateCSV={ this.state.showGenerateCSV }
          
          getEvaluations={ this.getEvaluations }
          getSelectedEvaluation={ this.getSelectedEvaluation }
          onChangeEvaluationsHOC={ this.onChangeEvaluationsHOC }/>
      )
    }
  }
  const mapStateToProps = state => ({ data: state })
  return  connect( mapStateToProps, {
    storeLastView
  } )( WithHOC )
}

export default HOC